var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loginRedirect"},[_c('iframe',{attrs:{"src":_vm.iframeSrc[_vm.$route.query.from][_vm.$route.query.run],"frameborder":"0","hidden":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }